
<template>
    <article v-resize:throttle="resize" v-if="shoot">
        <div class="heading">
            <h1>{{ shoot.title }}</h1>
            <p class="subheader">{{ shoot.location }} - {{ date( shoot.taken_at ) }}</p>
        </div>

        <ul v-if="layout" class="images" :style="`height:${ layout.containerHeight }px`">
            <li v-for="( photo, i ) in shoot.photos" :style="`top:${ layout.boxes[i].top }px;left:${ layout.boxes[i].left }px;width:${ layout.boxes[i].width }px;height:${ layout.boxes[i].height }px`">
                <router-link :to="{ name: 'photo', params: { photo_id: photo.photo_id } }">
                    <img :data-src="`${ photo.url }.thumb.jpg`" v-lazy-load :style="`width:${ layout.boxes[i].width }px;height:${ layout.boxes[i].height }px`"/>
                </router-link>
            </li>
        </ul>

        <router-view></router-view>
    </article>
</template>

<script>
    import moment from 'moment';
	import justify from 'justified-layout';
	import Shoot from '../models/Shoot';
	import resize from 'vue-resize-directive';

	export default
	{
		directives: {
			resize
		},
		computed:
        {
            justified()
            {
                this.layout = this.resize();
            },
        },
		data()
		{
			return {
                layout: null,
                selected: null,
                shoot: null,
			};
		},
        methods:
        {
	        date( taken )
	        {
		        taken = new Date( taken );
		        return moment( taken.getTime() ).format( 'Do MMMM YYYY' );
	        },
            resize()
            {
	            const photos = ( this.shoot instanceof Shoot ?
		            this.shoot.photos : [] ).map( photo => {
		            return { width: photo.width, height: photo.height };
	            });

	            if( ! photos.length )
		            this.layout = null;


	            this.layout = justify( photos, {
		            boxSpacing: 6,
		            containerPadding: 0,
		            containerWidth: this.$el.parentElement.clientWidth,
		            targetRowHeight: 220,
	            });
            }
        },
		mounted()
		{
			Shoot.fetch( this.id )
                .then( shoot => this.shoot = shoot );
		},
		props:
        {
            id: {
                required: true,
                type: String,
                //type: Number,
            }
        },
	}
</script>
